import React, { useEffect, useState } from "react";
import { TablePagination } from "@mui/material";
import Moment from "moment";
import DataTable from "../../../Table/DataTable";

import { Link, useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../../../services";
import { ToastManager } from "../../../common/ToastContainer";
import FullPageProgress from "../../../common/FullPageProgress";
import { SESSION_AUTH } from "../../../../helpers/auth";

const EventListChat = () => {
  const [loader, setLoader] = useState(false);
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState("");
  const [eventList, setEventList] = useState([]);
  const { eventId } = useParams();
  const [dataFetched, setDataFetched] = useState(false);

  const [totalRows, setTotalRows] = useState(0);
  const defaultFilter = {
    page: 0,
    limit: 10,
    eventId: eventId,
  };
  const [filter, setFilter] = useState(defaultFilter);

  useEffect(() => {
    if (userSession) {
      setUserData(userSession);
    } else {
      setUserData("");
    }
    return () => null;
  }, [userSession]);

  useEffect(() => {
    if (!userData || dataFetched) return;

    setLoader(true);
    setDataFetched(true);

    let parma = { ...filter };
    parma["userId"] = userData.userId;

    EVENTS_SERVICES.getEventsChats(parma)
      .then((data) => {
        setEventList([]);
        if (data.code === 200) {
          setEventList(data?.data?.list || []);
          if (data?.data?.pageInfo?.page === 0) {
            setTotalRows(data?.data?.pageInfo?.totalRows || 0);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [userData, dataFetched, LOGOUT_USER_SESSION, filter]);

  const columns = [
    {
      name: "sno",
      label: "S.No.",
    },

    {
      name: "sender",
      label: "Owner",
      options: {
        customBodyRender: (value) => {
          return (
            <Link
              className="text-link"
              to={`/events/users/${value?._id}/profile`}
              target="_blank"
            >
              {value?.name}
            </Link>
          );
        },
      },
    },
    {
      name: "message",
      label: "Message",
      options: {
        customBodyRender: (value) => {
          return <div style={{ whiteSpace: "normal" }}>{value}</div>;
        },
      },
    },

    {
      name: "createdAt",
      label: "Date",
    },

    {
      name: "level",
      label: "Level",
      options: {
        customBodyRender: (value) => {
          return <span className="text-status">{value}</span>;
        },
      },
    },

    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (item) => {
          return (
            <button
              type="button"
              className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
              onClick={() => deleteMessage(item?._id)}
            >
              Delete
            </button>
          );
        },
      },
    },
  ];

  const handleChangePage = (event, newPage) => {
    setFilter((old) => ({
      ...old,
      page: newPage,
    }));
    setDataFetched(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter((old) => ({
      ...old,
      limit: event.target.value,
      page: 0,
    }));
    setDataFetched(false);
  };

  const customOption = {
    pagination: false,
  };

  const deleteMessage = (id) => {
    let parma = {};
    parma["userId"] = userData.userId;
    parma["id"] = id;
    parma["eventId"] = eventId;
    setLoader(true);
    EVENTS_SERVICES.getEventsChatsDelete(parma)
      .then((data) => {
        setEventList([]);
        if (data.code === 200) {
          setDataFetched(false);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <>
      {loader && <FullPageProgress />}

      <DataTable
        columns={columns}
        customOption={customOption}
        data={eventList.map((item, key) => {
          return {
            sno: filter?.page * filter?.limit + key + 1,
            message: item.message,
            eventType: item,
            sender: item.sender,
            level: item?.level,
            createdAt: Moment(item?.createdAt).format("MMM DD, YYYY : hh:mm A"),
            id: item?._id,
            action: item,
          };
        })}
      />

      <TablePagination
        component="div"
        count={totalRows}
        page={filter.page}
        onPageChange={handleChangePage}
        rowsPerPage={filter.limit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        showFirstButton={true}
        showLastButton={true}
      />
    </>
  );
};

export default EventListChat;
